import Box from "@mui/material/Box";
import { Checkbox, Grid, OutlinedInput, Radio, TextareaAutosize } from "@mui/material";

// テキストボックス　フォーカス時に全選択する
const onFocusInput = (event) => {event.target.select()}

const getEventValue = (event) =>  event.target.value;

const getEventIntegerValue = (event) =>  event.target.value.replaceAll(/[^0-9]/g, "");

const getEventCheckedValue = (event) =>  event.target.checked;

const setInputEventValue = (conditionInput, setConditionInput, prop, getEventValueFunc = getEventValue) => (event) => {
  setConditionInput({...conditionInput, [prop]: getEventValueFunc(event)});
}



export function ScheduleConditionApplyDateRangeForm({conditionInput, setConditionInput}) {
  return (
    <Box>
      <OutlinedInput 
        type="date"
        inputProps={{
          min: "1000-01-01",
          max: "9999-12-31",
        }}
        sx={{marginRight: 1}}
        onChange={setInputEventValue(conditionInput, setConditionInput, "apply_start_date", getEventValue)}
        value={conditionInput.apply_start_date}       
      />
      から
      <OutlinedInput 
        type="date"
        inputProps={{
          min: "1000-01-01",
          max: "9999-12-31",
        }}
        sx={{marginLeft: 1, marginRight: 1}}
        onChange={setInputEventValue(conditionInput, setConditionInput, "apply_end_date", getEventValue)}
        value={conditionInput.apply_end_date}
      />
      まで
    </Box>
  )
}


export function ScheduleConditionDateForm({conditionInput, setConditionInput}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs="auto">
        <OutlinedInput
          sx={{width: 100, marginRight: 1}}
          onFocus={onFocusInput}
          onChange={setInputEventValue(conditionInput, setConditionInput,"month", getEventValue)}
          onBlur={setInputEventValue(conditionInput, setConditionInput,"month", getEventIntegerValue)}
          value={conditionInput.month}
          disabled={conditionInput.every_month}
        />
        月
        <OutlinedInput
          sx={{width: 100, marginLeft: 1, marginRight: 1}}
          onFocus={onFocusInput}
          onChange={setInputEventValue(conditionInput, setConditionInput,"date", getEventValue)}
          onBlur={setInputEventValue(conditionInput, setConditionInput,"date", getEventIntegerValue)}
          value={conditionInput.date} 
        />
        日
      </Grid>
      <Grid item xs="auto">
        <Checkbox 
          onChange={setInputEventValue(conditionInput, setConditionInput,"every_month", getEventCheckedValue)}
          checked={conditionInput.every_month}
        />
        毎月適用
      </Grid>
    </Grid>
  )
}

export function ScheduleConditionDayWeekForm({conditionInput, setConditionInput}) {

  const setDaySelected = setInputEventValue(conditionInput, setConditionInput,"day_code", getEventValue)

  return (
    <Grid container spacing={2}>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs="auto">
            <Radio
              onChange={setDaySelected}
              value={""} checked={conditionInput.day_code === ""}
            /> 設定なし
          </Grid>
          <Grid item xs="auto">
            <Radio
              onChange={setDaySelected}
              value={"7"} checked={conditionInput.day_code === "7"}
            /> 日
          </Grid>
          <Grid item xs="auto">
            <Radio
              onChange={setDaySelected}
              value={"1"} checked={conditionInput.day_code === "1"}
            /> 月
          </Grid>
          <Grid item xs="auto">
            <Radio
              onChange={setDaySelected}
              value={"2"} checked={conditionInput.day_code === "2"}
            /> 火
          </Grid>
          <Grid item xs="auto">
            <Radio
              onChange={setDaySelected}
              value={"3"} checked={conditionInput.day_code === "3"}
            /> 水
          </Grid>
          <Grid item xs="auto">
            <Radio
              onChange={setDaySelected}
              value={"4"} checked={conditionInput.day_code === "4"}
            /> 木
          </Grid>
          <Grid item xs="auto">
            <Radio
              onChange={setDaySelected}
              value={"5"} checked={conditionInput.day_code === "5"}
            /> 金
          </Grid>
          <Grid item xs="auto">
            <Radio
              onChange={setDaySelected}
              value={"6"} checked={conditionInput.day_code === "6"}
            /> 土
          </Grid>  
        </Grid>
        <Box>
          <Checkbox
            onChange={setInputEventValue(conditionInput, setConditionInput, "certain_week_apply", getEventCheckedValue)}
            checked={conditionInput.certain_week_apply}
            disabled={conditionInput.day_code === ""}
          />
          毎月第
          <OutlinedInput
            sx={{width: 100, marginLeft: 1, marginRight: 1}}
            onFocus={onFocusInput}
            onChange={setInputEventValue(conditionInput, setConditionInput, "week", getEventValue)}
            onBlur={setInputEventValue(conditionInput, setConditionInput, "week", getEventIntegerValue)}
            value={conditionInput.week}
            disabled={!conditionInput.certain_week_apply || conditionInput.day_code === ""}
          />
          の選択曜日に適用
        </Box>
      </Grid>              
    </Grid>
  )
}

export function ScheduleConditionHolidayForm({conditionInput, setConditionInput}) {

  return (
    <Grid container>
      <Grid item xs="auto">
        <Checkbox
          onChange={
            conditionInput.not_holiday_apply
              ? setInputEventValue(conditionInput, setConditionInput, "holiday_apply", getEventCheckedValue)
              : null
            }
          checked={conditionInput.holiday_apply}
        />
        祝日に適用
      </Grid>
      <Grid item xs="auto">
        <Checkbox
          onChange={
            conditionInput.holiday_apply
              ? setInputEventValue(conditionInput, setConditionInput, "not_holiday_apply", getEventCheckedValue)
              : null
            }
          checked={conditionInput.not_holiday_apply}             
        />
        祝日以外に適用
      </Grid>           
    </Grid>
  )
}

export function ScheduleConditionMemoForm({conditionInput, setConditionInput}) {
  return (
    <TextareaAutosize                
      minRows={5} maxRows={5}
      style={{ width: 400, resize: "none" }}
      onChange={setInputEventValue(conditionInput, setConditionInput, "memo", getEventValue)}
      value={conditionInput.memo}
    />
  )
}

